<div class="col-12">
    <ngx-ui-loader [loaderId]="recentlyAddedCustomersLoader"
                   bgsColor="rgb(100, 181, 246)"
                   bgsPosition="center-center"
                   bgsType="ball-spin"
                   overlayColor="rgba(0, 0, 0, 0.1)"></ngx-ui-loader>
</div>

<div>
    <div *ngIf="noRecentlyAddedCustomers">No new FuelerLinx operators have signed up in the preceding 30-days</div>
    <div *ngIf="!noRecentlyAddedCustomers" class="subtitle">These operators have signed up for FuelerLinx in the past 30 days:</div>
    <div *ngIf="!noRecentlyAddedCustomers">
        <div *ngFor="let customer of keys">
            <div class="row">
                <div class="col border-bottom pt-3 pb-3">{{ customer }}</div>
                <div class="col border-bottom pt-3 pb-3">
                    <button (click)="goToCustomerDetails(customer)" [view]="'accent'" size="small" ni-button>
                        Go to Customer Manager
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
